//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      order: {}, //头数据
      items: [], //物料列表
      activeFujian: [""],
      fujianFileList: [], //文件列表 用于展示
      /** 反馈日期 */
      showDatePicker: false,
      pickIndex: -1,
      pickDate: moment().startOf("day").toDate(), //选中日期
      minDate: moment().subtract(1, "year").toDate(), //最小可选
      maxDate: moment().add(1, "year").toDate(), //最大可选
      /** 选中物料 */
      checkIndexs: [],
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
    //是否外部用户 用户判断可否编辑物料
    isExternal: {
      get() {
        return this.userInfo.userType === "EXTERNAL";
      },
      set() {},
    },
    //是否显示确认提交按钮
    showSubmitBtn: {
      get() {
        return !(this.checkIndexs == null || this.checkIndexs.length == 0);
      },
      set() {},
    },
  },
  created() {
    this.requestOrder();
    this.requestItems();
  },
  activated: function () {},
  methods: {
    isCheckboxAll(){
      console.log('执行了');
      // 全部选中，并跳过禁用的复选框
      this.$refs.checkboxGroup.toggleAll({
        skipDisabled: true,
      });
    },
    requestOrder() {
      fetch
        .orderMobileFindById({
          lan: this.languageCode,
          poHeaderId: this.$route.query.poHeaderId,
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              this.order = res.data;
              this.initFilds();
            }
          }
        });
    },
    requestItems() {
      fetch
        .orderListByPageLine({
          lan: this.languageCode,
          poHeaderId: this.$route.query.poHeaderId,
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              this.items = res.data;
            }
          }
        });
    },
    //格式化月份
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    //确认反馈日期
    onConfirmDate(date) {
      const deliverDate = moment(date).format("YYYY-MM-DD");
      const item = this.items[this.pickIndex]; //选中物料
      item.feedbackDeliveryDate = deliverDate; //更新日期
      //重置选择器
      this.pickIndex = -1;
      this.showDatePicker = false;
    },
    //确认交期
    confirm() {
      if (this.checkIndexs == null || this.checkIndexs.length == 0) {
        return;
      }
      const params = [];
      this.checkIndexs.forEach((index) => {
        const item = JSON.parse(JSON.stringify(this.items[index]));
        item.lan = this.languageCode;
        params.push(item);
      });
      fetch.doSupplierDeliveryConfirm(params).then((res) => {
        if (res.status === "S") {
          if (res.status === "S") {
            this.requestItems();
          }
        }
      });
    },
    //切换选中状态
    toggle(item, index) {
      if (this.isEditAble(item)) {
        this.$refs.checkboxes[index].toggle();
      }
    },
    //点击反馈日期
    onClickFeedbackDate(item, index) {
      if (!this.isEditAble(item)) return;
      //设置选中日期
      const date =
        item.feedbackDeliveryDate == null
          ? moment().startOf("day").toDate()
          : moment(item.feedbackDeliveryDate).toDate();
      this.pickDate = date;
      this.pickIndex = index; //记录物料index
      this.showDatePicker = true;
    },
    //判断当前物料是否可编辑
    isEditAble(item) {
      if (!this.isExternal) {
        //外部用户
        return false;
      }
      if (
        item.feedbackStatus === "PENDING_FEEDBACK" || //待反馈
        item.feedbackStatus === "ADJUSTMENT_NO" //调整拒绝
      ) {
        return true;
      }
      return false;
    },
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    //获取头部信息后，初始化附件列表
    initFilds() {
      const ids = JSON.parse(JSON.stringify(this.order.fileIds));
      if (ids == null || ids == "") return;
      // const ids = "5290,5319"
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: ids,
        })
        .then((res) => {
          if (res.status === "S" && res.status === "S") {
            this.fujianFileList = res.data.map((fujian) => {
              return {
                status: "done",
                file: {
                  name: fujian.originalFileName,
                },
                path: fujian.filePath,
                fileId: fujian.id,
                download: true,
              };
            });
            console.log(this.fujianFileList);
          }
        });
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(()=>{
      this.isCheckboxAll()
    })
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/order/order.vue